import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/CommonService';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import 'firebase/storage';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.css']
})
export class LandingpageComponent implements OnInit {
  hdpe: any;
  brand: any;
  id: any;

  constructor(private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private storage: AngularFireStorage) {
  }
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    console.log(this.id);
    this.getInfoBrand(this.id);
    this.getListLineProductOfBrand(this.id);
  }

  //get infor of brand
  getInfoBrand(id: string) {
    this.commonService.getInfoRoot(id).snapshotChanges().subscribe(hdpe => {
      this.hdpe = hdpe.payload.val();
      let linkImage: Observable<string | null>;
      const ref = this.storage.ref('images/' + this.hdpe.avatar);
      linkImage = ref.getDownloadURL();
      this.hdpe.avatar = linkImage;
    });
  }

  //get all line of product of each brand
  getListLineProductOfBrand(id: string) {
    this.commonService.getListLineProductOfBrand(id).snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ key: c.payload.key, ...c.payload.val() })
        )
      )
    ).subscribe(brand => {
      this.brand = brand;
      for (let index = 0; index < this.brand.length; index++) {
        let linkImage: Observable<string | null>;
        const ref = this.storage.ref('images/' + this.brand[index].avatar);
        linkImage = ref.getDownloadURL();
        this.brand[index].avatar = linkImage;
      }
    });
  }

}
